import { generateRandomNum } from './modifiers';

const createCutPaperPath = () => {
	return `polygon(${generateRandomNum(31.5, 33)}% ${generateRandomNum(3.5, 5.5)}%,${generateRandomNum(
		71.2,
		75
	)}% ${generateRandomNum(1.5, 4)}%, ${generateRandomNum(100, 100)}% ${generateRandomNum(0.5, 3)}%,${generateRandomNum(100, 100)}% ${generateRandomNum(
		85.5,
		88.5
	)}%, ${generateRandomNum(74.6, 80)}% ${generateRandomNum(86, 91)}%,  ${generateRandomNum(39.7, 43)}% ${generateRandomNum(
		85.8,
		90
	)}%, ${generateRandomNum(0, 2)}% ${generateRandomNum(86.3, 92)}%, ${generateRandomNum(0, 2)}% ${generateRandomNum(
		5.5,
		8.5
	)}%)`;
};

const getContrastYIQ = hexcolor => {
	hexcolor = hexcolor.replace('#', '');
	const r = parseInt(hexcolor.substring(0, 2), 16);
	const g = parseInt(hexcolor.substring(2, 2), 16);
	const b = parseInt(hexcolor.substring(4, 2), 16);
	const yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq >= 128 ? 'black' : 'white';
};

const toggleIsVisible = (imageSrc, imageAlt, useActions = false, price = '0', imageSubtitle = '', onLightBoxActionClick = () => {}) => {
	const lightBox = document.querySelector('[data-light-box-popup]');
	lightBox.classList.toggle('hiding');
	lightBox.parentElement.classList.toggle('hiding');
	const lightBoxImage = lightBox.querySelector('[data-light-box-image]');
	const lightBoxActions = lightBox.querySelector('[data-light-box-popup-actions]');
	lightBoxImage.src = imageSrc;
	lightBoxImage.alt = imageAlt;

	if (useActions) {
		lightBoxActions.classList.toggle('pair-imp-none');
		lightBoxActions.classList.add('d-flex');
		const lightBoxTitle = lightBox.querySelector('[data-light-box-popup-title]');
		const lightBoxSubtitle = lightBox.querySelector('[data-light-box-popup-subtitle]');
		const lightBoxButton = lightBox.querySelector('[data-light-box-popup-button]');
		const lightBoxPrice = lightBox.querySelector('[data-light-box-popup-price]');
		lightBoxTitle.innerHTML = imageAlt;
		lightBoxSubtitle.innerHTML = imageSubtitle;
		lightBoxPrice.innerHTML = price;

		if (lightBoxButton.onclick) {
			lightBoxButton.onclick = (event) => {
				onLightBoxActionClick(event);
				lightBox.classList.add('hiding');
				lightBox.parentElement.classList.add('hiding');
			};
		}
	} else if (!lightBoxActions.classList.contains('pair-imp-none')) {
		lightBoxActions.classList.remove('d-flex');
		lightBoxActions.classList.add('pair-imp-none');
	}
};

export { createCutPaperPath, getContrastYIQ, toggleIsVisible };
